<script>
import { clearMobileNotificationHistory, unregisterMobileDevice } from "@/mobile/service";

export default {
  name: "authentication-logout",
  render() {
    return false
  },
  async created() {
    try {
      await unregisterMobileDevice();
    } catch (error) {
      // Local sign-out and privacy cleanup must continue if the device is offline.
    } finally {
      clearMobileNotificationHistory();
      localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`)
      localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}organizationId`)
      this.$router.replace("/login")
    }
  },
}
</script>
